import React from 'react'

const LoginScreen = () => {
  return (
    <div>
      <h4>Login Screen</h4>
    </div>
  )
}

export default LoginScreen
